import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import LanguageActivate from '@/views/Language/dialogs/languageActivate/languageActivate.vue'
import ConfirmDelete from '@/views/Language/dialogs/confirmDelete/confirmDelete.vue'
import LanguageAdd from '@/views/Language/dialogs/languageAdd/languageAdd.vue'

import store from '@/store'
import { i18n } from '@/plugins/i18n'
export default class LanguageModel extends JsonApiObject {
    static async getFinalStrings(lang = ['nob', 'eng'], tags = ['front-end']) {
        let query = {
            filters: {
                lang,
                tags,
            },
        }

        let res = await Vue.prototype.$vbit.get('language', 'effectiveTexts', query)

        if (res) {
            store.commit('effectiveTexts', res.data)
        }
        return res
    }

    static async initPost() {
        return await JsonApiObject.openDialog(LanguageAdd, {})
    }

    static async post(language) {
        if (language) {
            let query = {
                include: ['globalStatistics'],
                body: {
                    data: {
                        type: 'language',
                        id: language,
                    },
                },
            }

            let res = await Vue.prototype.$vbit.post('language', `languages`, query)

            if (res) {
                await LanguageModel.getAllTranslationLanguages()
            }

            return res
        }
    }

    static async get(stringId: string) {
        let query = {
            include: ['globalStatistics'],
        }

        let res = await Vue.prototype.$vbit.get('language', `languages/${stringId}`, query)

        return res.data ? new LanguageModel(res.data, res.included) : res
    }
    static async getAllLanguages() {
        let res = await Vue.prototype.$vbit.request(
            'get',
            'https://language.api.vbit.com/languages'
        )

        let languages = res.data.map((language) => new LanguageModel(language, res.included))

        store.commit('languages', languages)

        return languages
    }

    static async getAllTranslationLanguages() {
        let query = {
            include: ['globalStatistics'],
        }

        let res = await Vue.prototype.$vbit.get('language', `languages`, query)

        let languages = res.data.map((language) => new LanguageModel(language, res.included))

        store.commit('translationLanguages', languages)

        return languages
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    culture
    availableForUsers
    deleted
    writable
    createdAt
    updatedAt

    get globalStatistics() {
        return this._relationships['globalStatistics']
            ? this._relationships['globalStatistics']
            : null
    }

    async activate() {
        let res = await JsonApiObject.openDialog(LanguageActivate, {
            language: this._id,
        })

        if (res) {
            let data = {
                id: this._id,
                type: this._type,
                attributes: {
                    availableForUsers: true,
                },
            }

            return await this.patch(data)
        }
    }

    async delete() {
        let res = await JsonApiObject.openDialog(ConfirmDelete, {
            name: this._id ? i18n.t(`languages.${this._id}`) : '',
            deleted: this.deleted,
            type: 'language',
            needConfirm: true,
        })
        if (res) {
            let data = {
                id: this._id,
                type: this._type,
                attributes: {
                    deleted: !this.deleted,
                },
            }

            return await this.patch(data)
        }
    }

    async patch(data: any) {
        let query = {
            updatedAt: this['updatedAt'],
            include: ['globalStatistics'],
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.patch('language', `languages/${this._id}`, query)

        if (res.data) {
            let lang = new LanguageModel(res.data, res.included)
            store.commit('translationLanguage', lang)
            return lang
        } else {
            return res
        }
    }
}
